// Fixed-term retainers: a retainer defines at most one of an end date or a number of billing cycles.
// With neither it is open-ended (renewable), with either it stops billing at the end of the term.

export const RETAINER_TERM_NONE = 'none'
export const RETAINER_TERM_END_DATE = 'end-date'
export const RETAINER_TERM_BILLING_CYCLES = 'billing-cycles'

// YYYY-MM-DD of the given instant in UTC
export function utcIsoDate (date = new Date()) {
  return date.toISOString().slice(0, 10)
}

// YYYY-MM-DD of a Date as picked in the browser (input[type=date] models are local midnight)
export function localIsoDate (date) {
  const pad = value => String(value).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

// The API requires an end date strictly after today in UTC, so tomorrow (UTC) at the earliest
export function minRetainerEndDate (now = new Date()) {
  const tomorrow = new Date(now.getTime())
  tomorrow.setUTCDate(tomorrow.getUTCDate() + 1)
  return utcIsoDate(tomorrow)
}

export function isFixedTermRetainer (task) {
  return Boolean(task && task.retainer && (task.retainerEndDate || task.retainerBillingCycles))
}

// The API refuses payment once the end date is today or earlier (UTC). Billing cycles never expire this way.
export function isRetainerTermEnded (task, now = new Date()) {
  if (!task || !task.retainer || !task.retainerEndDate) {
    return false
  }
  return String(task.retainerEndDate).slice(0, 10) <= utcIsoDate(now)
}
